import { actions } from './actions';
import { mutations } from './mutations';
export var types = {
    SET_COMPANY: 'setCompany',
    SET_COMPANY_TAGS: 'setCompanyTags',
    SET_LOADING: 'setLoading',
    SET_LOADING_TAGS: 'setLoadingTags',
    SET_USERS: 'setUsers',
};
export var state = {
    company: null,
    loading: false,
    loadingTags: false,
    tags: [],
    users: [],
};
export var companyModule = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
